<dx-popup
  [width]="'90%'"
  [maxWidth]="750"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'TRAINING-QUESTIONNAIRE.ANSWER.ADDITIONAL-QUESTIONS' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [visible]="showModal"
>
  <div *dxTemplate="let data of 'content'">
    <div class="questions-container">
      <dx-scroll-view
        [height]="'auto'"
        [useNative]="true"
        [showScrollbar]="'always'"
        class="questions-scroll"
      >
        <app-answer-training-questions-dialog
          [questions]="questions"
          [remainingParticipantSlots]="remainingParticipantSlots"
        ></app-answer-training-questions-dialog>
      </dx-scroll-view>

      <div class="terms">
        <dx-check-box
          #checkbox
          [(value)]="isTermsAccepted"
        ></dx-check-box>

        <label class="terms-label" (click)="toggleCheckbox(checkbox)">
          {{ 'MY-INVITATION.TERMS' | translate }}
          <span class="required"> *</span>
        </label>
      </div>      

      <div class="form-cta">
        <dx-button
          [text]="'COMMON.CANCEL' | translate"
          type="default"
          (click)="onCancelClick()"
        ></dx-button>
        <dx-button
          [disabled]="!isTermsAccepted"
          [text]="'MY-INVITATION.SEND' | translate"
          type="normal"
          (click)="acceptTraining()"
        ></dx-button>
      </div>
    </div>
  </div>
</dx-popup>
